export default (() => {
    console.log('UNTUCKit : Module : CustomCheckbox : loaded');
    const onPlaceholderActivate = (event) => {
        if (!(event.currentTarget instanceof HTMLElement)) {
            return;
        }
        if (event.type === 'keydown') {
            const keyEvent = event;
            // Match the previous jQuery handler: only Enter (code + keyCode) toggles.
            if (keyEvent.code !== 'Enter' || keyEvent.keyCode !== 13) {
                return;
            }
        }
        const realCheckboxId = event.currentTarget.dataset.checkbox;
        if (!realCheckboxId) {
            return;
        }
        const realCheckbox = document.getElementById(realCheckboxId);
        if (!(realCheckbox instanceof HTMLInputElement)) {
            return;
        }
        realCheckbox.checked = !realCheckbox.checked;
        event.currentTarget.classList.toggle('checkbox-placeholder--checked');
    };
    const init = () => {
        console.log('UNTUCKit : Module : CustomCheckbox : init');
        document.querySelectorAll('.js-checkbox-placeholder').forEach((placeholder) => {
            // Clicks on the wrapping label would toggle the real checkbox as well.
            placeholder.parentElement?.addEventListener('click', (event) => {
                event.preventDefault();
            });
            placeholder.addEventListener('click', onPlaceholderActivate);
            placeholder.addEventListener('keydown', onPlaceholderActivate);
        });
    };
    return { init };
})();
